import handleNateApiResponse from '@/helpers/handle_nate_api_response.js';
import useStationsStore from '@/stores/stations';

export default async function performNateApiRequest({ station, endpoint }) {
  if (!station?.nateApiUrl) {
    return;
  }

  const stationsStore = useStationsStore();
  const { refreshOne } = stationsStore;

  const response = await fetch(`${station.nateApiUrl}${endpoint}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  });

  let data = null;

  try {
    data = await response.json();
  } catch (error) {}

  if (data) {
    handleNateApiResponse(data);
  }

  await refreshOne({ host: station.host });
}
